import {createGlobalStyle} from 'styled-components';

import FigTreeVariable from "../../resources/fonts/Figtree-VariableFont_wght.woff";

export default createGlobalStyle`
    @font-face {
        font-family: "FigTree-Standard";
        font-style: normal;
        font-weight: normal;
        src: url(${FigTreeVariable}) format("woff");
    }

    @font-face {
        font-family: "FigTree-Medium";
        font-style: normal;
        font-weight: 600;
        src: url(${FigTreeVariable}) format("woff");
    }

    body {
        margin: 0;
        font-family: "FigTree-Standard", sans-serif !important;
        font-optical-sizing: auto;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
    }

    .clearfix:after {
        content: " "; /* Older browser do not support empty content */
        visibility: hidden;
        display: block;
        height: 0;
        clear: both;
    }
`